import React, { useState } from "react";
import { Navbar } from "../../components/Navbar";
import { Sidebar } from "../../components/Sidebar";
import { FaImage, FaCheck } from "react-icons/fa";
import useApi from "../../hooks/useApi";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
import { useEffect } from "react";
import Rating from "@mui/material/Rating";
export default () => {
  const initialData = {
    app_status: true,
    email_notification: true,
    communication: 5,
    professionalism: 5,
    quality: 5,
    timeliness: 5,
    complete_install: true,
    complete_removal: true,
    complete_training: true,
  };
  const value = {
    // communication: submitData.communication,
    // professionalism: 0,
    // quality: 0,
    // timeliness: 0,
  };

  const [submitData, setSubmitData] = useState(initialData);
  const handleChange = (key, value) => {
    setSubmitData({
      ...submitData,
      [key]: value,
    });
  };
  const { request, loading, error } = useApi((submitData) =>
    apiClient.put("/installerSetting", submitData)
  );
  useEffect(() => {
    const fetchData = async () => {
      const response = await apiClient.get("/installerSetting");
      console.log(response,"setdata")
      const data = response?.data;
      setSubmitData(data);
    };

    fetchData();
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(submitData,"set")
    const result = await request(submitData);
    if (result.status === 200) {
      toast.success("Account Succesfully Created");
    } else {
      toast.error("Error");
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="site-content h-100">
          <div className="p-4">
            <div className="site-content-body">
              <section className="notification-sec mt-4">
                <div className="container">
                  <div className="row notification-main d-flex justify-content-between">
                    <div className="col-lg-6 pe-md-4">
                      <h3 className="notify-head lh-base fs-3 fw-bold blue-clr position-relative">
                        Notifications
                      </h3>
                      <div className="mt-5">
                        <div className="mt-5">
                          <div className="toggle d-flex align-items-center">
                            <label
                              htmlFor="a_notification"
                              className="blue-clr fs-4 lh-base"
                            >
                              App Notifications
                            </label>
                            <input
                              checked={submitData?.app_status}
                              type="checkbox"
                              id="a_notification"
                              className="notify-check ms-4"
                              onClick={(e) => {
                                handleChange(
                                  "app_notification",
                                  e.target.checked
                                );
                              }}
                            />
                          </div>
                        </div>
                        <div className="mt-3">
                          <div className="toggle d-flex align-items-center">
                            <label
                              htmlFor="e_notification"
                              className="blue-clr fs-4 lh-base"
                            >
                              Email Notifications
                            </label>
                            <input
                              checked={submitData?.email_notification}
                              type="checkbox"
                              id="e_notification"
                              className="notify-check ms-2"
                              onClick={(e) =>
                                handleChange(
                                  "email_notification",
                                  e.target.checked
                                )
                              }
                            />
                          </div>
                        </div>
                        <h3 className="notify-head lh-base fs-3 fw-bold blue-clr mt-4 position-relative">
                          My Rating
                        </h3>
                        <div className="notify-icon mt-5 d-flex flex-wrap ">
                          <Rating
                            name="simple-controlled"
                            value={5}
                            onChange={(value) => {
                              handleChange("communication", value);
                            }}
                          />
                          <span className="ms-sm-2 blue-clr mt-2 mt-sm-0 fs-4 lh-base">
                            Communication
                          </span>
                        </div>
                        <div className="notify-icon mt-3 d-flex flex-wrap">
                          <Rating
                            name="simple-controlled"
                            value={5}
                            onChange={(value) => {
                              handleChange("professionalism", value);
                            }}
                          />

                          <span className="ms-sm-2 blue-clr mt-2 mt-sm-0 fs-4 lh-base">
                            Professionalism
                          </span>
                        </div>
                        <div className="notify-icon mt-3 d-flex flex-wrap">
                          <Rating
                            name="simple-controlled"
                            value={5}
                            onChange={(value) => {
                              handleChange("quality", value);
                            }}
                          />
                          <span className="ms-sm-2 blue-clr mt-2 mt-sm-0 fs-4 lh-base">
                            Quality
                          </span>
                        </div>
                        <div className="notify-icon mt-3 d-flex flex-wrap">
                          <Rating
                            // disabled
                            name="simple-controlled"
                            value={5}
                            onChange={(value) => {
                              handleChange("timeliness", value);
                            }}
                          />
                          <span className="ms-sm-2 blue-clr mt-2 mt-sm-0 fs-4 lh-base">
                            Timeliness
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 ps-md-4 mt-5 mt-md-0">
                      <div>
                        <h3 className="notify-head lh-base fs-3 fw-bold blue-clr position-relative">
                          Rolling Adz Certification
                        </h3>
                      </div>
                      <div className="row mt-4">
                        <div className="mt-3 d-flex align-items-center ">
                          <input
                            disabled
                            checked={submitData?.complete_install}
                            type="checkbox"
                            id="p_shoot"
                            className="chk"
                            onClick={(e) =>
                              handleChange("complete_install", e.target.checked)
                            }
                          />
                          <label
                            htmlFor="p_shoot"
                            className="notify-h fs-4 lh-base blue-clr ms-1"
                          >
                            Complete 3 Installs
                          </label>
                        </div>
                        <div className="mt-3 d-flex align-items-center">
                          <input
                            disabled
                            checked={submitData?.complete_removal}
                            type="checkbox"
                            id="v_shoot"
                            className="chk"
                            onClick={(e) =>
                              handleChange("complete_removal", e.target.checked)
                            }
                          />
                          <label
                            htmlFor="v_shoot"
                            className="notify-h fs-4 lh-base blue-clr ms-1"
                          >
                            Complete 3 Removals
                          </label>
                        </div>
                        <div className="mt-3 d-flex align-items-center">
                          <input
                            disabled
                            checked={submitData?.complete_training}
                            type="checkbox"
                            id="m_vehicle"
                            className="chk"
                            onClick={(e) =>
                              handleChange(
                                "complete_training",
                                e.target.checked
                              )
                            }
                          />
                          <label
                            htmlFor="m_vehicle"
                            className="notify-h fs-4 lh-base blue-clr ms-1"
                          >
                            Complete Training Video
                          </label>
                        </div>
                        <div className="line position-relative mt-3" />
                        <div className="download-b mt-4">
                          <button type="button" className="btn p-3 w-100">
                            Download Certificate
                          </button>
                          <span className="d-block download-s fs-4 lh-base mt-2 text-center">
                            Congrats! You are now a certified go-to rolling Adz
                            Installer!
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center mt-5 save-main">
                      <button type="submit" className="btn_bgnone btn blue-clr">
                        <span className="pe-2">Save Changes</span>
                        <FaCheck />
                      </button>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
